export default {
  translation: {
    common: {
      accept: 'Prinyat',
      alreadyUser: 'Uzhe est akkount?',
      and: 'i',
      backToLogin: 'Vernutsya na stranicu vhoda',
      continueWith: 'Prodolzhit cherez {{provider}}',
      coreNotFound: 'Ne udalos zagruzit osnovnye nastroyki',
      createAccount: 'Sozdat akkount',
      createYourAccount: 'Sozdayte akkount',
      emailOrUsername: 'Email ili imya polzovatelya',
      invalidUsernameOrPassword: 'Nevernoe imya polzovatelya ili parol',
      localRegistrationDisabled: 'Lokalnaya registraciya otklyuchena administratorom',
      login: 'Voyti',
      logInToBoards: 'Voyti',
      newToBoards: 'Vpervye v 4ga Boards?',
      noInternetConnection: 'Net podklyucheniya k internetu',
      pageNotFound_title: 'Stranica ne naydena',
      password: 'Parol',
      policyNotAccepted: 'Primiite Usloviya ispolzovaniya i Politiku konfidencialnosti',
      privacyPolicy: 'Politika konfidencialnosti',
      register: 'Zaregistrirovatsya',
      registerWithGoogle: 'Zaregistrirovatsya cherez Google',
      registrationDisabled: 'Registraciya polzovateley otklyuchena administratorom',
      serverConnectionFailed: 'Ne udalos podklyuchitsya k serveru',
      ssoRegistrationDisabled: 'SSO-registraciya otklyuchena administratorom',
      termsOfService: 'Usloviya ispolzovaniya',
      togglePasswordVisibility: 'Pokazat/skryt parol',
      unknownError: 'Neznaya oshibka, poprobuyte pozzhe',
    },

    action: {
      logIn: 'Voyti',
    },
  },
};
